import { MultiSelectControlledOption } from "components";

export const getStatusOptions = (
  options: { key: string; value: string }[],
): MultiSelectControlledOption[] =>
  Array.isArray(options)
    ? options.map(({ key, value }) => ({
        name: value,
        label: value,
        value: key,
      }))
    : [];